module.exports = __webpack_public_path__ + "img/玉蘭貞潔_四方連續_線稿_black.882c61c4.png";